export default function BookAppointment() {
    return(
        <section>
            <iframe className="w-100 booking-frame" title="book appointment" src="https://usa4.recallmax.com/rsm/request/public/bookOnline/patient/layout.html?a=RGgwS5eWDtKkT8v0xPALTE5P_XPr8t1ZM"></iframe>
        </section>
    );
}